/**
 * Singbac Incorporation (Pre) — live UI 값 → Word 렌더용 정규화.
 *
 * PRE 3종(Constitution · Form 45B Consent · Notice to Controller) 은 대부분 단순 [[변수]] 치환이나
 * 두 가지 계산이 필요하다:
 *  1) Constitution 의 subscribers 반복부([[if subscribers]] … [[/if subscribers]])
 *     — 화면 키 sub{id}_subscriber_* → subscribers[] 배열.
 *  2) Form 45B 의 secretary 자격 선택(sec_qual = 'i'|'ii'|…) → 체크박스 조건식용 sec_qual_<key>='Yes'.
 * 회사명·등록주소 별칭도 함께 보정해 미치환(빈칸)을 없앤다.
 */
function txt(v: unknown): string {
  return v == null ? '' : String(v).trim();
}
function isFilled(v: unknown): boolean {
  return v != null && String(v).trim() !== '';
}

/** sub{id}_subscriber_* → subscribers[] ([[if subscribers]] … [[/if subscribers]]) */
function buildSubscribers(out: Record<string, any>) {
  if (Array.isArray(out.subscribers) && out.subscribers.length) return;
  const rows: Record<string, any>[] = [];
  for (let i = 1; i <= 30; i++) {
    const name = out[`sub${i}_subscriber_name`];
    const address = out[`sub${i}_subscriber_address`];
    const shares = out[`sub${i}_subscriber_shares`];
    if (!isFilled(name) && !isFilled(address) && !isFilled(shares)) continue;
    rows.push({
      subscriber_name: txt(name),
      subscriber_address: txt(address),
      subscriber_shares: txt(shares),
      // role 'both' 인원의 ID/국적 — E-Filing 병합용(문서 렌더에는 무해).
      subscriber_id: txt(out[`sub${i}_subscriber_id`]),
      subscriber_nationality: txt(out[`sub${i}_subscriber_nationality`]),
      // E-Filing 주주 생년월일·이메일·휴대폰(커스텀폼 자동채움) — 문서 렌더에는 무해.
      subscriber_dob: txt(out[`sub${i}_subscriber_dob`]),
      subscriber_email: txt(out[`sub${i}_subscriber_email`]),
      subscriber_mobile: txt(out[`sub${i}_subscriber_mobile`]),
    });
  }
  if (rows.length) out.subscribers = rows;
}

/** sec_qual('i'|'ii'|'iii'|'iiia'|'iv'|'v'|'vi') → sec_qual_<key>='Yes' (체크박스 조건식). */
const SEC_QUAL_KEYS = ['i', 'ii', 'iii', 'iiia', 'iv', 'v', 'vi'] as const;
function expandSecQual(out: Record<string, any>) {
  const sel = txt(out.sec_qual);
  for (const k of SEC_QUAL_KEYS) {
    out[`sec_qual_${k}`] = sel && sel === k ? 'Yes' : '';
  }
}

export function normalizeSingbacIncPreFormDataForWord(
  form: Record<string, any>,
): Record<string, any> {
  const out: Record<string, any> = { ...form };

  const alias = (target: string, source: string) => {
    if (!isFilled(out[target]) && isFilled(out[source])) out[target] = out[source];
  };
  // 등록사무소 주소 별칭(문서마다 표기가 다를 수 있어 양방향 보정)
  alias('registered_office_address', 'company_registered_address');
  alias('company_registered_address', 'registered_office_address');

  buildSubscribers(out);
  expandSecQual(out);

  return out;
}
